<section class="home-banner-wrapper">
    <div class="home-banner-slider">
        <!-- <div class="banner-items" style="background-image: url(assets/images/home-bg.webp);"> -->
            <!-- <link rel="preload" href="assets/images/home-bg.webp" as="image"> -->
            <div class="banner-items" style="background-image: url('assets/images/home-bg.webp');background-size: cover; background-position: center; background-repeat: no-repeat;">
            <div class="banner-text-block">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-12 col-xl-10 mx-auto text-center">
                            <h1 class="banner-tagline">All-in-One PDF Management Tools</h1>
                            <p class="header1">Our Free Tools: Easily Merge PDFs, Split Files, Add Watermarks, and More – Everything You Need to Simplify Your Everyday Document Management Tasks Online.
                            </p>
                                <app-showreview  [reviews]="Review"></app-showreview>
                                <!-- <app-rating [rating]="Review[3]"></app-rating> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>